import { useMutation } from "@tanstack/react-query";
import type { ClientErrorPayload } from "@unbox/api";
import { APIError, handleError } from "@/api/error";
import { globalHandleError } from "@/providers/QueryClientProviderWrapper";
import { client } from "../client";

export type TestErrorKind =
  | "formValidation"
  | "notFound"
  | "internalServer"
  | "auth"
  | "forbidden"
  | "validation"
  | "other"
  | "old"
  | "logged";

export const useTestAppError = (
  kind: TestErrorKind,
  onError: (err: Extract<ClientErrorPayload, { kind: "FormValidationError" }>) => void,
) => {
  return useMutation({
    mutationFn: async () => {
      const res = await client.admin.errors["app-error"].$post({
        query: { kind },
      });
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
    meta: { suppressGlobalError: true },
    onError: (err) => {
      if (err instanceof APIError && err.isKind("FormValidationError")) {
        onError(err.data);
      } else {
        globalHandleError(err);
      }
    },
  });
};

export const useTestTimeoutError = () => {
  return useMutation({
    mutationFn: async () => {
      const res = await client.admin.errors.timeout.$post({});
      if (!res.ok) throw await handleError(res);
      return await res.json();
    },
  });
};
